import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { Locale } from 'vant';
import enUS from 'vant/lib/locale/lang/en-US';
import jaJP from 'vant/lib/locale/lang/ja-JP';
import zhCN from 'vant/lib/locale/lang/zh-CN';
import en from '../assets/languages/en.json';
import ja from '../assets/languages/ja.json';
import kr from '../assets/languages/kr.json';
import fr from '../assets/languages/fr.json';
import es from '../assets/languages/es.json';
import zh from '../assets/languages/zh.json';
import { getLanguage, normalizeLocale } from '../common/language';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: getLanguage(),
  fallbackLocale: 'en',
  messages: { en, zh, ja, kr, fr, es }
});

// Vant does not ship French or Spanish packs — use English as the base.
const koKR = {
  ...enUS,
  confirm: kr.common.confirm,
  cancel: kr.common.cancel,
  save: kr.setting.save,
  loading: kr.common.loading,
  vanPullRefresh: { pulling: '아래로 당겨서 새로고침', loosing: '놓아서 새로고침' }
};
const frFR = {
  ...enUS,
  confirm: fr.common.confirm,
  cancel: fr.common.cancel,
  save: fr.setting.save,
  loading: fr.common.loading
};
const esES = {
  ...enUS,
  confirm: es.common.confirm,
  cancel: es.common.cancel,
  save: es.setting.save,
  loading: es.common.loading
};

const componentLocales = {
  en: ['en-US', enUS],
  zh: ['zh-CN', zhCN],
  ja: ['ja-JP', jaJP],
  kr: ['ko-KR', koKR],
  fr: ['fr-FR', frFR],
  es: ['es-ES', esES]
};

export function setLanguage(value) {
  const language = normalizeLocale(value);
  localStorage.setItem('lang', language);
  i18n.locale = language;
  const [componentLanguage, messages] = componentLocales[language] || componentLocales['en'];
  Locale.use(componentLanguage, messages);
  document.documentElement.lang = { en: 'en', zh: 'zh-CN', ja: 'ja', kr: 'ko', fr: 'fr', es: 'es' }[language] || 'en';
  return language;
}

setLanguage(i18n.locale);

export default i18n;
